module.exports = __webpack_public_path__ + "img/r3_type.df45d592.png";